import i18n from '../i18n';

const INTL_LOCALE_MAP = {
  sk: 'sk-SK',
  en: 'en-US',
  de: 'de-DE',
};

export function resolveIntlLocale(locale) {
  const code = locale || i18n.language || 'sk';
  return INTL_LOCALE_MAP[code] || INTL_LOCALE_MAP.sk;
}

export function formatDate(value, locale) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat(resolveIntlLocale(locale), {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(date);
}

export function formatDateTime(value, locale) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat(resolveIntlLocale(locale), {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

export function formatCurrency(amount, currency = 'EUR', locale) {
  if (amount === null || amount === undefined || amount === '') return '—';
  const numeric = Number(amount);
  if (Number.isNaN(numeric)) return String(amount);
  return new Intl.NumberFormat(resolveIntlLocale(locale), {
    style: 'currency',
    currency: currency || 'EUR',
  }).format(numeric);
}

export function formatNumber(value, locale) {
  if (value === null || value === undefined || value === '') return '—';
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return String(value);
  return new Intl.NumberFormat(resolveIntlLocale(locale)).format(numeric);
}
